<script setup>
// Sample labels, tilted and drifting on staggered offsets so the group reads as
// a loose pile rather than a row of chips.
const LABELS = [
  {
    id: 'sales',
    tint: 'bg-n-teal-3 text-n-teal-11',
    tilt: '-rotate-6',
    delay: '',
  },
  {
    id: 'billing',
    tint: 'bg-n-iris-3 text-n-iris-11',
    tilt: 'rotate-3',
    delay: '[animation-delay:-1.2s]',
  },
  {
    id: 'vip',
    tint: 'bg-n-amber-3 text-n-amber-11',
    tilt: '-rotate-2',
    delay: '[animation-delay:-2.1s]',
  },
  {
    id: 'bugs',
    tint: 'bg-n-ruby-3 text-n-ruby-11',
    tilt: 'rotate-[4deg]',
    delay: '[animation-delay:-3s]',
  },
];
</script>

<template>
  <div class="flex flex-wrap justify-center gap-2.5 px-5" aria-hidden="true">
    <span
      v-for="label in LABELS"
      :key="label.id"
      class="px-3.5 py-1.5 text-xs font-semibold rounded-full motion-safe:animate-onboarding-float"
      :class="[label.tint, label.tilt, label.delay]"
    >
      #{{ label.id }}
    </span>
  </div>
</template>
